import userManager, { onLogin } from "../../auth/AuthManager"

export const Login = () => {
    onLogin();

    return <div>Login...</div>;
}